import { render } from "./OrderCell.vue?vue&type=template&id=e36aefb2"
import script from "./OrderCell.vue?vue&type=script&lang=js"
export * from "./OrderCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__